import { createSession, destroySession, getSessionValue } from "./session";
import { GenerateCodeParams, ValidateCodeParams } from "src/interfaces";
import { http } from "./http";

export const generateCode = (params: GenerateCodeParams) => {
  return http.post("bulkyScheduler/verificationCode/generate", params).then((response) => {
    return response.data;
  });
};

export const validateCode = async (params: ValidateCodeParams) => {
  const response = await http.post("bulkyScheduler/verificationCode/validate", params);
  const vendorUrl = params.vendorUrl;
  createSession(response.headers.authorization, {
    vendorUrl,
    phone: params.phone,
    email: params.email,
  });

  return response.data;
};

export const validateVendorURL = (vendorUrl: string) => {
  return http.get(`/bulkyScheduler/city/validate/?vendorUrl=${vendorUrl}`).then((response) => {
    return response.data;
  });
};

export const logOut = () => {
  destroySession();
};

export const getAuthToken = () => getSessionValue("authToken");
export const getUserCookie = () => getSessionValue("user");
